import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { components } from 'react-select';
import { VrrButton, VrrDropdown } from '../../shared_components';
import BrandModal from '../../menu/brand_modal';
import { getCurrentBrand, prepareBrands } from './services';
import useSettings from '../../../libs/settings/useSettings';
import {
  fetchBrands,
  getBrands,
  getFeatures,
  getUserId
} from '../../../redux/app/appActions';
import { getVrrPreferences } from '../../../redux/settings/settingAction';
import { PrivateComponent } from '../../permissions';
import { getFeatureByPath } from '../../routing/services';
import { updateLabel } from '../../../redux/app/appSlice';
import { IListState } from '../../shared_components/vrr_dropdown/types';
import './BrandDropdown.scss';

const BrandDropdown: React.FC = () => {
  const { t } = useTranslation();
  const { vrr } = useSettings();
  const dispatch: any = useDispatch();
  const features = useSelector(getFeatures);
  const userId = useSelector(getUserId);
  const brands = useSelector(getBrands);
  const settings = useSelector(getVrrPreferences);
  const [brand, setBrand] = useState<string | undefined>(undefined);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (userId) {
      dispatch(fetchBrands());
    }
  }, [userId]);

  useEffect(() => {
    if (brands && settings) {
      setBrand(
        getCurrentBrand(settings?.current_brand_id, prepareBrands(brands))
      );
    }
  }, [brands, settings]);

  const onChange = (newBrand: IListState | null) => {
    if (settings?.resource_id) {
      vrr({ current_brand_id: newBrand?.value });
      setBrand(newBrand?.value);
      dispatch(updateLabel('all'));
    }
  };

  const Menu = (props: any) => {
    return (
      <components.Menu {...props}>
        {props.children}
        <PrivateComponent
          authorizationStrategy={() =>
            getFeatureByPath(features, 'navbar.add_brands')
          }
        >
          <VrrButton
            className="brand-dropdown-add-brand btn-with-icon-and-label icon-left"
            icon={{
              iconLabel: 'tim-icons icon-cloud-download-93'
            }}
            onClick={() => setIsOpen(true)}
          >
            {t('main_navbar.brand_dropdown.button')}
          </VrrButton>
        </PrivateComponent>
      </components.Menu>
    );
  };

  return (
    <div className="brand-dropdown">
      <VrrDropdown
        placeholder={t('main_navbar.brand_dropdown.placeholder')}
        noOptionsMessage={t('main_navbar.brand_dropdown.empty')}
        list={prepareBrands(brands)}
        currentValue={brand}
        handleChangeAction={onChange}
        customComponents={{ Menu }}
      />
      <BrandModal isOpen={isOpen} onCancelAction={() => setIsOpen(false)} />
    </div>
  );
};

export default BrandDropdown;
